import {
  CLEAR_PROPS_FOR_QUOTATION,
  CREATE_TPWQ_SUCCESS,
  FETCH_TPW_NO_SUCCESS,
  FETCH_TPWQ_SUCCESS,
  GET_TPWQ_SUCCESS,
  SAVE_TPWQ_QUERY,
  STORE_TOTAL_DATA_FOR_LABOUR,
  STORE_TOTAL_DATA_FOR_SPARE,
} from "../../constants/ActionTypes";

let spareSum = [];
let labourSum = [];

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  tpwSno : '',
  sparesTotal : [],
  labourTotal : [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_TPWQ_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_TPWQ_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;
      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_TPWQ_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case CLEAR_PROPS_FOR_QUOTATION: {
      return {
        ...state,
        sparesTotal : [],
        labourTotal : [],
        tpwSno : '',
      }
    }

    case FETCH_TPWQ_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case FETCH_TPW_NO_SUCCESS: {
      return {
        ...state,
        tpwSno: action.data,
      }
    }

    case STORE_TOTAL_DATA_FOR_SPARE: {
      //spareSum[action.data && action.data.index] = action.data && action.data.data;
      state.sparesTotal[action.data && action.data.index] = action.data && action.data.data;
      if(action.data && action.data.removeIndex) {
        state.sparesTotal[action.data.removeIndex] = 0;
      }
      return {
        ...state,
        sparesTotal: state.sparesTotal,
      }
    }

    case STORE_TOTAL_DATA_FOR_LABOUR: {
      //labourSum[action.data && action.data.index] = action.data && action.data.data;
      state.labourTotal[action.data && action.data.index] = action.data && action.data.data;
      if(action.data && action.data.removeIndex) {
        state.labourTotal[action.data.removeIndex] = 0;
      }
      return {
        ...state,
        labourTotal: state.labourTotal,
      }
    }

    default:
      return state;
  }
}
